import React, { useEffect, useState } from "react";
import { useLanguage } from "@/context/LanguageContext";
import { useConsent } from "@/context/ConsentContext";
import {
  buildGeneralMessage,
  buildWhatsAppUrl,
  trackWhatsAppClick,
} from "@/lib/whatsapp";
import { WhatsAppIcon } from "./WhatsAppIcon";

// Floating WhatsApp widget. Stacks above the cookie banner on mobile until a
// consent decision is made.
export function WhatsAppWidget() {
  const { lang } = useLanguage();
  const { analyticsAllowed, decided, ready } = useConsent();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 320);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const href = buildWhatsAppUrl(buildGeneralMessage(lang));
  const handleClick = () => {
    if (analyticsAllowed) trackWhatsAppClick({ serviceKey: "general", lang, source: "floating-widget" });
  };

  const bottomClass = ready && !decided ? "bottom-40 sm:bottom-6" : "bottom-6";

  return (
    <a
      href={href}
      onClick={handleClick}
      data-testid="floating-whatsapp-widget"
      aria-label="WhatsApp"
      className={`fixed right-5 ${bottomClass} z-40 inline-flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-black shadow-[0_10px_30px_rgba(0,0,0,0.45)] transition-all duration-300 hover:scale-105 ${
        show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4 pointer-events-none"
      }`}
    >
      <span className="absolute inline-flex h-full w-full rounded-full bg-[#25D366] opacity-40 animate-ping" style={{ animationDuration: "3s" }} aria-hidden="true" />
      <WhatsAppIcon className="relative h-7 w-7" />
    </a>
  );
}
